import { useMutation, useQueryClient } from '@tanstack/react-query';
import costCategoriesApi from '@/features/dashboard/costCategories/api/costCategoriesApi.ts';
import { costCategoriesApiQueryKeys } from '@/features/dashboard/costCategories/api/costCategoriesApi.queryKeys.ts';
import { toast } from 'sonner';

export default function useUnarchiveCostCategory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => costCategoriesApi.unarchive(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: costCategoriesApiQueryKeys.all(),
      });
      toast.success('Kategoria kosztów została przywrócona');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message ||
          'Wystąpił błąd podczas przywracania kategorii kosztów.',
      });
    },
  });
}
